import React from "react";
import styles from "./ProgressBar.module.scss";
import range from "lodash/range";

interface ProgressBarProps {
  percentage: number;
  segments?: number;
}

export default function ProgressBar({
  percentage,
  segments = 1,
}: ProgressBarProps) {
  return (
    <div className={styles.root}>
      <div className={styles.background} />
      <div className={styles.foreground} style={{ width: `${percentage}%` }} />
      {segments > 1 && (
        <div className={styles.segments}>
          {range(segments - 1).map((segmentIndex) => (
            <div key={`segment_${segmentIndex}`} className={styles.segment} />
          ))}
        </div>
      )}
    </div>
  );
}
